import { render, staticRenderFns } from "./Decline.vue?vue&type=template&id=0befe0a6&scoped=true&"
import script from "./Decline.vue?vue&type=script&lang=js&"
export * from "./Decline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0befe0a6",
  null
  
)

export default component.exports